import {
  Box,
  IconButton,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalHeader,
  ModalFooter,
  ModalCloseButton,
  useDisclosure,
} from "@chakra-ui/react";

import { FcFullTrash } from "react-icons/fc";

interface Props {
  title: string;
  id: string;
  size?: string;
  handleDelete: (id: string) => Promise<any>;
  loading: boolean;
}
const DeleteItem: React.VFC<Props> = ({
  title,
  id,
  size = "md",
  handleDelete,
  loading,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const deleteItem = async (id: string) => {
    await handleDelete(id);
    onClose();
  };
  return (
    <Box>
      <IconButton
        size={size}
        icon={<FcFullTrash />}
        aria-label="Delete Item"
        onClick={onOpen}
      />
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Silme İşlemi</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {title} isimli öğeyi siliyorsunuz. Bu işlem geri alınamaz, emin misiniz?
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Vazgeç
            </Button>
            <Button
              isDisabled={loading}
              colorScheme={"red"}
              onClick={() => deleteItem(id)}
            >
              Sil
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default DeleteItem;
